<template>
	<div>
        <icons></icons>

        <div>
            <h2>
                Custom Assessment
            </h2>

            <p class="p-reserving__summary">
                Our unique reserving function allows you to perform accurate day one assessments of reserves based on your concluded claims history.
            </p>

            <p class="u-margin-bottom-20">
                Assess and analyse reserves on your entire book of claims. Perform predictive analysis to help with IBNR assessments.
            </p>

            <p class="u-margin-bottom-20">
                Changes in IBNR requirements following discount rate changes can be performed in seconds &mdash; even for 1000s of claims.
            </p>
        </div>
    </div>
</template>

<script type="text/babel">
	import Control from 'components/form/Control.vue';
	import SwitchButton from 'components/form/SwitchButton.vue';
	import Icons from 'components/Icons.vue';
    import FilterOptions from 'components/filter/FilterOptions.vue';
    import OptionFilters from 'components/OptionFilters.vue';
    import LineChart from 'components/graphs/LineChart.js';
    import BarChart from 'components/graphs/BarChart.js';
    import ScatterChart from 'components/graphs/ScatterChart.js';

	export default {
		components: {Control, SwitchButton, Icons, FilterOptions, OptionFilters, LineChart, BarChart, ScatterChart},
        methods: {
            isRouteByName (routeName) {
                return this.$route.name == routeName;
            },
        },
        props: {
            /*increase/decrease props*/
            fatalAverageReserve: {
                type:Boolean,
                default: true
            },
            fatalReserveRange: {
                type:Boolean,
                default: false
            },
            fatalNumberOfClaims: {
                type:Boolean,
                default: true
            },
            lostAverageReserve: {
                type:Boolean,
                default: true
            },
            lostReserveRange: {
                type:Boolean,
                default: true
            },
            lostNumberOfClaims: {
                type:Boolean,
                default: true
            },
        },
	}
</script>

<style>
    #confidence{width: 100px; padding: 0 0 0 40px; margin-top: -16px;}
    .confidence{width:100px;}
    .confidence0{fill-rule:evenodd;clip-rule:evenodd;fill:#FF007F;}
    .confidence1{fill-rule:evenodd;clip-rule:evenodd;fill:#00FFC8;}
    .confidence2{fill-rule:evenodd;clip-rule:evenodd;fill:#FF6D52;}
    .confidence3{fill-rule:evenodd;clip-rule:evenodd;fill:#394A49;}
</style>



// WEBPACK FOOTER //
// CustomAssessment.vue?4bceb9f6